// Shared UPI-app registry + logos for the web (payment page + dashboard).
// Keys match the backend upi_service.UPI_APPS registry: phonepe | paytm | upi.
// Real brand logos are served as static files from /public/brands (the Paytm
// SVG has a <style> block that CRA's SVGR can't transform, so we reference by
// URL rather than importing).
const PUB = process.env.PUBLIC_URL || "";

// The P2P-selectable apps (PhonePe/Paytm). "upi" is the generic fallback logo,
// not a selectable P2P option.
export const UPI_APPS = [
  { key: "phonepe", label: "PhonePe", short: "PhonePe", bg: "#5F259F", border: "#5F259F" },
  { key: "paytm", label: "Paytm", short: "Paytm", bg: "#FFFFFF", border: "#E3E3E3" },
];

export const UPI_APP_MAP = Object.fromEntries(UPI_APPS.map((a) => [a.key, a]));

// Real brand lockups (horizontal). These carry the brand name, so render them on
// their own (no extra text label). `height` drives the size; width is intrinsic.
export const BRAND_LOGOS = { phonepe: `${PUB}/brands/phonepe.png`, paytm: `${PUB}/brands/paytm.svg` };

export function BrandLogo({ app, height = 22, style }) {
  const src = BRAND_LOGOS[app];
  if (!src) return <UpiAppLogo app={app} size={height} />;
  return (
    <img
      src={src}
      alt={UPI_APP_MAP[app]?.label || app}
      style={{ height, width: "auto", display: "block", objectFit: "contain", ...style }}
    />
  );
}

// Compact square mark — used only for the generic "upi" fallback and tight cells.
export function UpiAppLogo({ app, size = 28 }) {
  const s = size;
  const common = { width: s, height: s, viewBox: "0 0 48 48", xmlns: "http://www.w3.org/2000/svg" };
  if (app === "phonepe") {
    return (
      <svg {...common} aria-label="PhonePe">
        <rect width="48" height="48" rx="11" fill="#5F259F" />
        <circle cx="24" cy="24" r="14" fill="#5F259F" stroke="#fff" strokeWidth="1.5" />
        <text x="24" y="30" textAnchor="middle" fontFamily="Arial, sans-serif" fontWeight="700" fontSize="16" fontStyle="italic" fill="#fff">Pe</text>
      </svg>
    );
  }
  if (app === "paytm") {
    return (
      <svg {...common} aria-label="Paytm">
        <rect width="48" height="48" rx="11" fill="#fff" stroke="#E3E3E3" />
        <text x="24" y="29" textAnchor="middle" fontFamily="Arial, sans-serif" fontWeight="800" fontSize="12">
          <tspan fill="#002970">Pay</tspan><tspan fill="#00BAF2">tm</tspan>
        </text>
      </svg>
    );
  }
  // generic UPI — neutral mark in the NPCI green/orange
  return (
    <svg {...common} aria-label="Any UPI app">
      <rect width="48" height="48" rx="11" fill="#fff" stroke="#E3E3E3" />
      <path d="M18 12 L27 24 L18 36 Z" fill="#FF7A00" />
      <path d="M23 12 L32 24 L23 36 Z" fill="#0A7D2C" />
      <text x="24" y="44" textAnchor="middle" fontFamily="Arial, sans-serif" fontWeight="800" fontSize="8" fill="#3a3550">UPI</text>
    </svg>
  );
}

export default UpiAppLogo;
